import { gql } from "@apollo/client";

export const GET_USERS_QUERY = gql`
  query getUsers($query: QueryInput, $user: UserInput) {
    users(query: $query, user: $user) {
      users {
        _id
        name
        email
        role
        active
        created_at
        updated_at
      }
      metaData {
        totalCount
        totalPages
        limit
      }
    }
  }
`;
